import React from 'react';
import { Box } from 'theme-ui';

function ContentBox({ children }) {
  return (
    <Box bg="white" py={[3, 4]} px={[2, 3]}>
      {children}
    </Box>
  );
}

export default ContentBox;
